<template>
  <div class="payment">
    <div class="pagementView">
      <div class="pagementViewTopTitle_">
        <div>订单提交成功！请尽快完成付款</div>
      </div>
      <div class="container_code">
        <div>作品名称:人世间</div>
        <div>应付金额：￥300</div>
      </div>
      <div class="tab_title">
        <div
          v-for="item in pageData.typeData.list"
          :key="item"
          :class="item.type == pageData.typeData.type ? 'active' : ''"
          @click="typeClick(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="qrCodeView">
        <iframe
          :srcdoc="pageData.qrCodePara"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          scrolling="no"
          style="overflow: hidden"
        >
        </iframe>
      </div>
      <div class="txt_">请使用支付宝扫码，支付成功后版权登记提交审核</div>
    </div>
  </div>
</template>

<script>
import { reactive, 
onUnmounted 
} from "vue";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";

import {
  orderPay,
  orderGeyOrderPayStatus,
} from "../../api/interfaceList.js";
export default {
  name: "payment",
  components: {},
  setup(prop,context) {
    let pageData = reactive({
      qrCodePara: "",
      orderCode: "",
      typeData: {
        type: 1,
        list: [
          {
            title: "支付宝",
            type: 1,
          },
          // {
          //   title: "微信",
          //   type: 2,
          // },
        ],
      },
    });
    function typeClick(e) {
      pageData.typeData.type = e.type;
    }
    orderPay({
      orderType: 1,
      payWay: 2,
      platform: 3,
      resourceCode: Cookies.get("uniqueCode"),
      userCode: JSON.parse(Cookies.get("userInformation")).userCode,
    }).then((res) => {
      if (res.code == 1) {
        ElMessage({
          message: res.message,
          type: "success",
        });
        pageData.qrCodePara = res.data[0].qrCodePara;
        pageData.orderCode = res.data[0].orderCode;
      }
    });

    let setInterval_ = setInterval(() => {
      orderGeyOrderPayStatus({
        orderCode: pageData.orderCode,
      }).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: res.message,
            type: "success",
          });
          let json = {
            key: 5,
            isOk: true,
          };
          context.emit("isOk", json);
          clearInterval(setInterval_);
        }
      });
    }, 1000);
    onUnmounted(() => {
      clearInterval(setInterval_);
    });
    return {
      pageData,
      typeClick,
    };
  },
};
</script>
<style lang="scss" scoped>
.payment {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  .pagementView {
    width: 570px;
    background: #ffffff;
    border-radius: 8px;
    padding: 20px 32px 24px 32px;
    box-sizing: border-box;
    margin-bottom: 40px;
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    // align-items: center;
    .txt_ {
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #606266;
      text-align: center;
    }
    .qrCodeView {
      width: 150px;
      height: 150px;
      overflow: hidden;
      // background: #ccc;
      margin: 24px auto;
      img {
        width: 144px;
      }
    }
    .tab_title {
      border-bottom: 1px #e6e6e6 solid;
      display: flex;
      align-items: center;
      justify-content: center;
      .active {
        color: #008aea;
        border-bottom: 4px #008aea solid;
      }
      div {
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        height: 64px;
        line-height: 64px;
        margin-right: 46px;
        padding: 0 8px;
        box-sizing: border-box;
        font-weight: 700;
        cursor: pointer;
      }
      div:last-of-type {
        margin: 0;
      }
    }
    .pay_view {
      padding: 24px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .right_ {
        width: 240px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 8px;
        font-weight: 700;
        cursor: pointer;
      }
      .right_:hover {
        background: #6dbbfc;
        transition: 0.4s all;
      }
      .left_ {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
        span {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #008aea;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .scopeAuthorization {
      padding: 16px 0 16px 10px;
      display: flex;
      justify-content: space-between;
      .right_ {
        width: 200px;
        .item_ {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          .fontStyle {
            color: #303133;
          }
          div:nth-of-type(1) {
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #303133;
          }
          div:nth-of-type(2) {
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #008aea;
          }
        }
      }
      .left_ {
        width: 300px;
        .title_ {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
        }
        .item_ {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          div {
            padding: 6px;
            box-sizing: border-box;
            background: #f5f7fa;
            border-radius: 12px;
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #008aea;
            margin: 8px 8px 0 0;
          }
        }
      }
    }
    .container_detail {
      padding: 16px 0 16px 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px #e6e6e6 solid;
      .right_ {
        width: 450px;
        .bot_txt {
          display: flex;
          justify-content: space-between;
          align-items: center;
          div:nth-of-type(1) {
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
          }
          div:nth-of-type(2) {
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #008aea;
          }
        }
        .title {
          font-size: 14px;
          font-family: AlibabaPuHuiTiB;
          color: #606266;
          border-bottom: 6px;
        }
      }
      .poster_ {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 48px;
        }
      }
    }
    .container_code {
      padding: 16px 10px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #606266;
      border-bottom: 1px #e6e6e6 solid;
      font-weight: 700;
      div:first-of-type {
        margin-bottom: 8px;
      }
    }
    .pagementViewTopTitle_ {
      width: 100%;
      background: rgba(5, 213, 97, 0.15);
      border-radius: 6px;
      padding: 10px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #4a9c5e;
      line-height: 18px;
      font-weight: 700;
    }
  }
}
</style>
